import { AlertDialog, DialogEntity } from '@lyearn/molecules';
import * as User from '@/components/User';

import { LearnerActionModalProps } from './types';

const LearnerActionModal: React.FC<LearnerActionModalProps> = (props) => {
  const { learner, action, header, onClose } = props;

  return (
    <AlertDialog contentClassName="w-full" header={header} primaryAction={action} onClose={onClose}>
      <User.Provider className="flex flex-col" user={learner}>
        <DialogEntity
          descriptionNode={
            <User.UniqueId
              className="truncate"
              color="text-text-secondary"
              variant="body-short-02"
            />
          }
          image={<User.ProfilePicture size={48} />}
          titleNode={<User.Name className="truncate" variant="body-short-01" />}
        />
      </User.Provider>
    </AlertDialog>
  );
};

export default LearnerActionModal;
